import { useMergeLink } from '@mergeapi/react-merge-link';
import { useCallback, useEffect } from 'react';
import { handleErrorToast, handleSuccessToast } from 'src/components/molecules';
import { useSubmitPublicTokenMutation } from 'src/graphql';

interface Props {
  onExit: () => void;
  linkToken: string;
}

export const MergeLink = ({ linkToken, onExit }: Props) => {
  const { mutate } = useSubmitPublicTokenMutation({
    onSuccess: () => {
      handleSuccessToast({ toastMessage: 'HRIS integration successful' });
    },
    onError: () => {
      handleErrorToast({ toastMessage: 'HRIS integration failed' });
    },
  });
  const onSuccess = useCallback((publicToken: string) => {
    mutate({ publicToken });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const { open, isReady } = useMergeLink({
    linkToken,
    onSuccess,
    tenantConfig: {
      apiBaseURL: 'https://api-eu.merge.dev',
    },
    onExit,
  });
  useEffect(() => {
    if (isReady) {
      open();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isReady]);

  return <></>;
};
